import { Card, H4 } from "@blueprintjs/core";
import React from "react";
import { LayoutDefault } from "../LayoutDefault";
import AuthMenu from "./AuthMenu";

const styleWrap = {
  display: "grid",
  gap: "20px",
  gridTemplateColumns: "auto 1fr",
  marginTop: "20px",
};

export const LayoutAuth = ({ children }) => {
  return (
    <LayoutDefault>
      <div style={{ ...styleWrap }}>
        <div>
          <AuthMenu />
        </div>

        <Card
          elevation={2}
          style={{ height: "calc(100vh - 90px)", overflow: "auto" }}
        >
          <H4>
            <a href="#">Jogosultságok</a>
          </H4>
          <div>{children}</div>
        </Card>
      </div>
    </LayoutDefault>
  );
};
